import React, { useMemo, useState } from "react";
import { toast } from "sonner";

const verdictFor = (iq) => {
  if (iq <= 25) return { label: "GIGARETARD — instant buy. welcome king.", color: "#2A9D8F", emoji: "👑" };
  if (iq <= 55) return { label: "certified retard. you may proceed.", color: "#E8742C", emoji: "🪖" };
  if (iq <= 90) return { label: "borderline retard. read whitepaper crayon edition.", color: "#F4A261", emoji: "🤔" };
  if (iq <= 130) return { label: "too smart. log off. touch grass.", color: "#457B9D", emoji: "🤓" };
  return { label: "GENIUS — NGMI. you'll overthink the buy button.", color: "#E63946", emoji: "🧠" };
};

const MIN = 0;
const MAX = 200;

export const IQGame = () => {
  const [iq, setIq] = useState(150);
  const verdict = useMemo(() => verdictFor(iq), [iq]);
  const pct = ((iq - MIN) / (MAX - MIN)) * 100;

  const handleTest = () => {
    // Weighted random: more likely to land in the retard range (gmi) for the lulz.
    const buckets = [
      { min: 0, max: 25, weight: 25 },     // GIGARETARD
      { min: 26, max: 55, weight: 30 },    // certified retard
      { min: 56, max: 90, weight: 20 },    // borderline
      { min: 91, max: 130, weight: 15 },   // too smart
      { min: 131, max: 200, weight: 10 },  // genius
    ];
    const total = buckets.reduce((s, b) => s + b.weight, 0);
    let r = Math.random() * total;
    let pick = buckets[0];
    for (const b of buckets) {
      if (r < b.weight) { pick = b; break; }
      r -= b.weight;
    }
    const score = Math.floor(Math.random() * (pick.max - pick.min + 1)) + pick.min;
    setIq(score);

    const v = verdictFor(score);
    if (score <= 90) {
      toast.success(`IQ ${score} — ${v.emoji} ${v.label}`, {
        description: "welcome to the club. propeller hat in the mail.",
      });
    } else {
      toast(`IQ ${score} — ${v.emoji} ${v.label}`, {
        description: "please lower your standards and try again.",
      });
    }
  };

  return (
    <section className="px-5 md:px-10 py-14" data-testid="iq-game-section">
      <style>{`
        .iq-slider {
          -webkit-appearance: none;
          appearance: none;
          width: 100%;
          height: 28px;
          background: transparent;
          cursor: grab;
        }
        .iq-slider:active { cursor: grabbing; }
        .iq-slider::-webkit-slider-runnable-track {
          height: 28px;
          border-radius: 999px;
          border: 4px solid #1A1A1A;
          background:
            linear-gradient(90deg, #2A9D8F 0%, #E8742C var(--iq-pct), #FFFDF6 var(--iq-pct), #FFFDF6 100%);
          box-shadow: 4px 4px 0 #1A1A1A inset, 0 0 0 0 transparent;
        }
        .iq-slider::-moz-range-track {
          height: 28px;
          border-radius: 999px;
          border: 4px solid #1A1A1A;
          background:
            linear-gradient(90deg, #2A9D8F 0%, #E8742C var(--iq-pct), #FFFDF6 var(--iq-pct), #FFFDF6 100%);
        }
        .iq-slider::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 54px;
          height: 54px;
          margin-top: -17px;
          background: #F4A261 url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'><circle cx='32' cy='32' r='6' fill='%231A1A1A'/></svg>") center/40% no-repeat;
          border: 4px solid #1A1A1A;
          border-radius: 999px;
          box-shadow: 4px 4px 0 #1A1A1A;
          transition: transform 100ms ease;
        }
        .iq-slider:hover::-webkit-slider-thumb { transform: rotate(-8deg) scale(1.06); }
        .iq-slider:active::-webkit-slider-thumb { transform: rotate(8deg) scale(1.1); box-shadow: 1px 1px 0 #1A1A1A; }
        .iq-slider::-moz-range-thumb {
          width: 54px;
          height: 54px;
          background: #F4A261;
          border: 4px solid #1A1A1A;
          border-radius: 999px;
          box-shadow: 4px 4px 0 #1A1A1A;
        }
        .iq-slider:focus { outline: none; }
        .iq-slider:focus::-webkit-slider-thumb { box-shadow: 4px 4px 0 #1A1A1A, 0 0 0 4px rgba(232,116,44,0.4); }
      `}</style>

      <div className="max-w-4xl mx-auto crayon-card relative px-6 md:px-10 py-10 -rotate-1">
        <span className="tape" style={{ background: "rgba(69, 123, 157, 0.55)" }} />
        <h2 className="font-display text-5xl md:text-6xl text-center text-[#1A1A1A]">
          are you <span className="text-[#E8742C]">retarded</span> enough?
        </h2>
        <p className="text-center text-lg md:text-xl text-[#1A1A1A]/70 mt-1">
          slide it down. way down. yes lower. lower. perfect.
        </p>

        <div className="mt-10 px-2 md:px-6">
          <div className="flex items-center justify-between font-display text-xl md:text-2xl mb-4">
            <span className="flex items-center gap-2">
              <span className="inline-block w-3.5 h-3.5 rounded-full bg-[#2A9D8F] border-2 border-[#1A1A1A]" />
              retard (gmi)
            </span>
            <span className="flex items-center gap-2">
              genius (ngmi)
              <span className="inline-block w-3.5 h-3.5 rounded-full bg-[#E63946] border-2 border-[#1A1A1A]" />
            </span>
          </div>

          <input
            type="range"
            min={MIN}
            max={MAX}
            step={1}
            value={iq}
            onChange={(e) => setIq(Number(e.target.value))}
            className="iq-slider"
            style={{ "--iq-pct": `${pct}%` }}
            data-testid="iq-slider"
            aria-label="IQ slider"
          />

          {/* Tick labels under the slider */}
          <div className="grid grid-cols-5 mt-2 font-display text-sm md:text-base text-[#1A1A1A]/60">
            <span className="text-left">0</span>
            <span className="text-center">50</span>
            <span className="text-center">100</span>
            <span className="text-center">150</span>
            <span className="text-right">200</span>
          </div>

          <div className="mt-8 text-center">
            <div className="font-display text-4xl md:text-5xl text-[#1A1A1A]" data-testid="iq-value">
              your IQ: <span className="text-[#E8742C]">{iq}</span>
            </div>
            <div
              className="inline-block mt-4 px-5 py-2 border-4 border-[#1A1A1A] rounded-full font-display text-2xl md:text-3xl shadow-[4px_4px_0_#1A1A1A] max-w-full"
              style={{ background: verdict.color, color: "#fff" }}
              data-testid="iq-verdict"
            >
              <span className="mr-2">{verdict.emoji}</span>
              {verdict.label}
            </div>
          </div>

          <div className="mt-8 text-center">
            <button
              type="button"
              onClick={handleTest}
              className="crayon-btn crayon-btn--blue"
              data-testid="iq-test-button"
            >
              🎲 test my retardation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IQGame;
